import { Component, inject } from '@angular/core';
import { DatePipe, SlicePipe } from '@angular/common';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-hcc-details-dialog',
    providers: [DatePipe],
    imports: [
        SlicePipe,
        MatDialogTitle,
        MatDialogContent,
        MatIcon
    ],
    templateUrl: './hcc-details-dialog.component.html',
    styleUrl: './hcc-details-dialog.component.scss'
})
export class HccDetailsDialogComponent {
  readonly data = inject(MAT_DIALOG_DATA);
  readonly datePipe = inject(DatePipe);
  constructor(
    public dialogRef: MatDialogRef<HccDetailsDialogComponent>
  ) {}

  handleClose() {
    this.dialogRef.close();
  }

  transformDate(date: Date | undefined): string {
    if (!date) {
      return '';
    }
    return this.datePipe.transform(date, "MM/dd/yyyy") || '';
  }
}
